import { Button } from "@/components/ui/button";
import { CalendarCheck, Pencil, Trash2 } from "lucide-react";
import { t5 } from "./templateUtils";

export function FragmentRow({ t, DAYS, cellSlots, can, selected, toggleSelect, openApply, openEdit, removeTemplate, onCellClick }) {
  return (
    <>
      <div className={`px-3 py-2 border-b border-slate-100 flex items-start gap-2 sticky left-0 bg-white z-10 ${selected.has(t.name) ? "bg-rose-50" : ""}`} data-testid={`template-row-${t.name}`}>
        {can.has("templates.edit") && <input type="checkbox" checked={selected.has(t.name)} onChange={() => toggleSelect(t.name)} className="h-3.5 w-3.5 mt-0.5 accent-brand cursor-pointer" data-testid={`select-${t.name}`} />}
        <div className="min-w-0 flex-1">
          <div className="text-xs font-semibold text-slate-800 truncate">{t.participant_name || t.participant}</div>
          <div className="text-[10px] text-slate-400 truncate">{t.template_name}</div>
          <div className="flex gap-1 mt-1">
            {can.has("templates.edit") && <Button size="sm" className="h-6 text-[10px] px-2" style={{ backgroundColor: "#0D9488" }} onClick={() => openApply(t)} data-testid={`apply-${t.name}`}><CalendarCheck className="h-3 w-3 mr-0.5" />Apply</Button>}
            {can.has("templates.edit") && <Button size="sm" variant="outline" className="h-6 text-[10px] px-1.5" onClick={() => openEdit(t)} data-testid={`edit-${t.name}`}><Pencil className="h-3 w-3" /></Button>}
            {can.has("templates.delete") && <Button size="sm" variant="outline" className="h-6 text-[10px] px-1.5 text-red-600 border-red-200 hover:bg-red-50" onClick={() => removeTemplate(t)} data-testid={`delete-${t.name}`}><Trash2 className="h-3 w-3" /></Button>}
          </div>
        </div>
      </div>
      {DAYS.map(([lb, off]) => {
        const slots = cellSlots(t, off);
        return (
          <div key={off} onClick={can.has("templates.edit") ? () => onCellClick(t, off) : undefined}
            className={`px-1.5 py-2 border-b border-l border-slate-100 space-y-1 ${can.has("templates.edit") ? "cursor-pointer hover:bg-rose-50/60" : ""}`}
            data-testid={`cell-${t.name}-${off}`} role={can.has("templates.edit") ? "button" : undefined}>
            {slots.length === 0 ? (can.has("templates.edit")
              ? <div className="text-[10px] text-slate-300 text-center py-1">+ Add</div>
              : <div className="text-[10px] text-slate-200 text-center">·</div>) :
              slots.map((s, i) => (
                <div key={i} className="rounded bg-slate-50 border border-slate-200 px-1.5 py-1" data-testid={`cell-slot-${t.name}-${off}-${i}`}>
                  <div className="text-[10px] font-mono font-semibold text-slate-600">{t5(s.start_time)}–{t5(s.end_time)}</div>
                  <div className="text-[10px] text-slate-500 truncate">{s.worker_name || s.support_worker || "Unassigned"}</div>
                </div>
              ))}
          </div>
        );
      })}
    </>
  );
}
